import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  darkMode: localStorage.getItem('darkTheme') === 'true'
};

export const darkModeSlice = createSlice({
  name: 'darkMode',
  initialState,
  reducers: {
    toggleDarkMode: (state) => {
      state.darkMode = !state.darkMode;
      localStorage.setItem('darkTheme', state.darkMode.toString());
    }
  }
});

export const { toggleDarkMode } = darkModeSlice.actions;

export default darkModeSlice.reducer;






